import { i18n } from 'LibNeo'
import { PurchaseType, BgCreateWarning, AST_ERROR_KEYS, AST_ERROR_CODE } from 'Pages/ibro'

const prepareError = (errors: any): any => {
	if (!errors) return null
	if (typeof errors !== 'object') return errors
	if (Array.isArray(errors)) {
		return errors.map(prepareError)
	}
	return Object.keys(errors).map((key): any => {
		/* TODO-broker может это поправить, если будет описание формата ошибок от АСТ */
		if (AST_ERROR_KEYS.includes(key as AST_ERROR_CODE)) {
			return typeof errors[key] === 'string' ? errors[key] : JSON.stringify(errors[key])
		}
		if (typeof errors[key] === 'string') {
			return `${i18n(`errors.${key}`)}: ${i18n(`errors.${errors[key]}`)}`
		}
		if (Array.isArray(errors[key])) {
			return `${i18n(`errors.${key}`)}: ${prepareError(errors[key]).join('\n')}`
		}
		return null
	})
}

export const prepareErrors = (errors: any[]): any[] => {
	if (Array.isArray(errors)) return errors.map(prepareError)
	return []
}

export const getCountMessage = (count?: number): string => {
	if (count === 1) return 'одного из'
	if (count > 1) return 'нескольких'
	return ''
}

export const getPurchaseTypeMessage = (
	purchasetype: PurchaseType,
	type: BgCreateWarning
): string => {
	if (type === BgCreateWarning.MULTI_POLICY_ERROR)
		return purchasetype === PurchaseType.FZ223 ? 'лотов' : 'бенефициаров'
	return purchasetype === PurchaseType.FZ223 ? 'лота' : 'бенефициара'
}
